export const DEFAULT_CURRENCY_CODE = "USD";
export const DEFAULT_CURRENCY_SYMBOL = "$";
export const DEFAULT_EXCHANGE_RATE = 1;
export const CURRENCY_FIELD_KEY = "currency";
export const CURRENCY_SUFFIX_CODES = ["Yuan", "RUB", "SAR"];

// Workers cannot import this file.
// Keep this config duplicated in dataDownloaderWorker.js and in sync.
export const CURRENCY_CONFIG = {
  USD: {
    countryFlagCode: "US",
    displayLabel: "US Dollar ($)",
    symbol: "$",
    languageCode: "en-US",
    currencyCode: "USD",
    conversionRatio: 1.0,
  },
  Yuan: {
    countryFlagCode: "CN",
    displayLabel: "Chinese Yuan Renminbi (CN¥)",
    symbol: "CN¥",
    languageCode: "zh-CN",
    currencyCode: "CNY",
    conversionRatio: 7.18,
  },
  Euro: {
    countryFlagCode: "EU",
    displayLabel: "Euro (€)",
    symbol: "€",
    languageCode: "de-DE",
    currencyCode: "EUR",
    conversionRatio: 0.92,
  },
  JPY: {
    countryFlagCode: "JP",
    displayLabel: "Japanese Yen (¥)",
    symbol: "¥",
    languageCode: "ja-JP",
    currencyCode: "JPY",
    conversionRatio: 151.45,
  },
  BRL: {
    countryFlagCode: "BR",
    displayLabel: "Brazilian Real (R$)",
    symbol: "R$",
    languageCode: "pt-BR",
    currencyCode: "BRL",
    conversionRatio: 5.39,
  },
  ARS: {
    countryFlagCode: "AR",
    displayLabel: "Peso (Arg$)",
    symbol: "Arg$",
    languageCode: "es-AR",
    currencyCode: "ARS",
    conversionRatio: 915.15,
  },
  AUD: {
    countryFlagCode: "AU",
    displayLabel: "Australian Dollar (AU$)",
    symbol: "AU$",
    languageCode: "en-AU",
    currencyCode: "AUD",
    conversionRatio: 1.52,
  },
  CAD: {
    countryFlagCode: "CA",
    displayLabel: "Canadian Dollar (CA$)",
    symbol: "CA$",
    languageCode: "en-CA",
    currencyCode: "CAD",
    conversionRatio: 1.37,
  },
  INR: {
    countryFlagCode: "IN",
    displayLabel: "Indian Rupee (₹)",
    symbol: "₹",
    languageCode: "en-IN",
    currencyCode: "INR",
    conversionRatio: 83.68,
  },
  IDR: {
    countryFlagCode: "ID",
    displayLabel: "Indonesian Rupiah (Rp)",
    symbol: "Rp",
    languageCode: "id-ID",
    currencyCode: "IDR",
    conversionRatio: 15866.0,
  },
  KRW: {
    countryFlagCode: "KR",
    displayLabel: "South Korean Won (KRW)",
    symbol: "KRW",
    languageCode: "ko-KR",
    currencyCode: "KRW",
    conversionRatio: 1363.0,
  },
  MXN: {
    countryFlagCode: "MX",
    displayLabel: "Mexican Peso (Mex$)",
    symbol: "Mex$",
    languageCode: "es-MX",
    currencyCode: "MXN",
    conversionRatio: 18.32,
  },
  RUB: {
    countryFlagCode: "RU",
    displayLabel: "Russian Ruble (₽)",
    symbol: "₽",
    languageCode: "ru-RU",
    currencyCode: "RUB",
    conversionRatio: 92.82,
  },
  SAR: {
    countryFlagCode: "SA",
    displayLabel: "Saudi Riyal (SAR)",
    symbol: "SAR",
    languageCode: "ar-SA",
    currencyCode: "SAR",
    conversionRatio: 3.75,
  },
  ZAR: {
    countryFlagCode: "ZA",
    displayLabel: "South African Rand (R)",
    symbol: "R",
    languageCode: "en-ZA",
    currencyCode: "ZAR",
    conversionRatio: 18.33,
  },
  TRY: {
    countryFlagCode: "TR",
    displayLabel: "Turkish Lira (₺)",
    symbol: "₺",
    languageCode: "tr-TR",
    currencyCode: "TRY",
    conversionRatio: 32.88,
  },
  GBP: {
    countryFlagCode: "GB",
    displayLabel: "Pound Sterling (£)",
    symbol: "£",
    languageCode: "en-GB",
    currencyCode: "GBP",
    conversionRatio: 0.78,
  },
  PHP: {
    countryFlagCode: "PH",
    displayLabel: "Philippine Peso (Php)",
    symbol: "Php",
    languageCode: "en-PH",
    currencyCode: "PHP",
    conversionRatio: 56.0,
  },
  SGD: {
    countryFlagCode: "SG",
    displayLabel: "Singapore Dollar (SGD)",
    symbol: "SGD",
    languageCode: "en-SG",
    currencyCode: "SGD",
    conversionRatio: 1.4,
  },
};

/** symbol lookup: currencyCode → symbol (e.g. "USD" → "$") */
export const CURRENCY_SYMBOLS = Object.fromEntries(
  Object.entries(CURRENCY_CONFIG).map(([code, cfg]) => [code, cfg.symbol]),
);

/** symbol lookup: symbol → currencyCode (e.g. "$" → "USD") */
export const CURRENCY_CODES = Object.fromEntries(
  Object.entries(CURRENCY_CONFIG).map(([code, cfg]) => [cfg.symbol, code]),
);

/** exchange-rate label for non-USD currencies: currencyCode → "symbol/$" */
export const EXCHANGE_RATE_LABELS = Object.fromEntries(
  Object.entries(CURRENCY_CONFIG)
    .filter(([code]) => code !== DEFAULT_CURRENCY_CODE)
    .map(([code, cfg]) => [code, `${cfg.symbol}/$`]),
);
